<template>
  <v-card
      class="rounded-xl"
      outlined
      max-width="100%"
      tile
  >
    <v-card-title>
      <h6 class="mx-auto text-h6">Текущее место в общежитии</h6>
    </v-card-title>
    <v-row class="pa-2" justify="space-around" no-gutters>
      <v-card elevation="0">
        <v-icon size="25" left>fa-building</v-icon>
        <span class="text-subtitle-1">{{ nameHostel }}</span>
      </v-card>
      <v-card elevation="0">
        <v-icon size="25" left>fa fa-users</v-icon>
        <span class="text-subtitle-1">{{ nameSection }}</span>
      </v-card>
      <v-card elevation="0">
        <v-icon size="25" left>fa-bed</v-icon>
        <span class="text-subtitle-1">{{ nameRoom }}</span>
      </v-card>
    </v-row>
  </v-card>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import StatementHostelPDF from "../../../../../makepdfs/statement_hostel/statement_hostel_pdf";

export default {
  name: "CurrPlaceHostel",
  data: () => ({
    full_name: '',
    enabled: true,
  }),
  components: {},
  mounted: function () {
    this.GetCurrPlaceHostel();
  },
  computed: {
    ...mapState({
      curr_place_hostel: state => state.interactionStatement.curr_place_hostel,
    }),
    ...mapGetters({}),
    nameHostel() {
      return this.curr_place_hostel?.data?.name_hostel || "Неопределено";
    },
    nameSection() {
      if (!!this.curr_place_hostel?.data?.name_section) return 'Секция № ' + this.curr_place_hostel?.data?.name_section
      else return "Неопределено";
    },
    nameRoom() {
      if (!!this.curr_place_hostel?.data?.name_room) return 'Комната № ' + this.curr_place_hostel?.data?.name_room
      else return "Неопределено";
    },
  },
  watch: {},
  methods: {
    ...mapMutations({}),
    ...mapActions({
      GetCurrPlaceHostel: 'interactionStatement/GetCurrPlaceHostel',
    }),
  },
}
</script>

<style scoped>

</style>